import Blue from '~/core';

new Blue({
	name: 'Svg Icons',
	selector: '[data-svg]',
	async setup(icon) {
		let code = await fetch(icon.getAttribute('data-svg')).then(res => res.text());
	
		icon.insertAdjacentHTML('beforebegin', code);
		icon.parentElement.querySelector('svg').classList = icon.classList;
		icon.parentElement.removeChild(icon);
	}
})